// extracted by css-extract-rspack-plugin
export default {"item":"item-JuF42r"};